/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyExternalSystemSecret,
    ReadOnlyExternalSystemSecretFromJSON,
    ReadOnlyExternalSystemSecretFromJSONTyped,
    ReadOnlyExternalSystemSecretToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20013
 */
export interface InlineResponse20013 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20013
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20013
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20013
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyExternalSystemSecret>}
     * @memberof InlineResponse20013
     */
    results: Array<ReadOnlyExternalSystemSecret>;
}

export function InlineResponse20013FromJSON(json: any): InlineResponse20013 {
    return InlineResponse20013FromJSONTyped(json, false);
}

export function InlineResponse20013FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20013 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyExternalSystemSecretFromJSON)),
    };
}

export function InlineResponse20013ToJSON(value?: InlineResponse20013 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyExternalSystemSecretToJSON)),
    };
}


